import React, {
  useState,
  useCallback,
  useImperativeHandle,
  useEffect,
  forwardRef,
} from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Loading,
  Text,
  TextField,
  Select,
  InlineError,
  PageActions,
  InlineStack,
  Button,
  Toast,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";

const AddLanguage = forwardRef((props, ref) => {
  const [firstNameValue, setFirstNameValue] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = useCallback((value) => {
    setSelectedLanguage(value);
    setLanguageError("");
  }, []);
  const [optionsLanguages, setOptionsLanguages] = useState("");
  const [languageError, setLanguageError] = useState("");
  useEffect(() => {
    axios
      .get(`/settings/languages?filter[is_active]=0`)
      .then((result) => {
        result?.data?.data?.data &&
          setOptionsLanguages(
            result.data.data.data.map((item, index) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            })
          );
      })
      .catch((err) => console.log(err));
  }, []);
  useImperativeHandle(ref, () => ({
    handleSave() {
      if (selectedLanguage === "") {
        setLanguageError("Please select a language");
      } else {
        props.handleSavingState();
        const form_data = new FormData();
        form_data.append("_method", "PATCH");
        form_data.append("is_active", 1);
        axios
          .post(`/settings/languages/${selectedLanguage}`, form_data)
          .then((res) => {
            props.handleChangeModalAndRefresh();
          })
          .catch((err) => console.log(""));
      }
    },
  }));
  return (
    <FormLayout>
      <Text variant="bodyMd" as="p" fontWeight="semibold">
        Language
      </Text>
      <Select
        placeholder="Please select"
        options={optionsLanguages}
        onChange={handleSelectChangeLanguage}
        value={selectedLanguage}
        error={languageError}
      />
    </FormLayout>
  );
});

export default AddLanguage;
